var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_162_5529)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 3,
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4001 30C20.8972 30 21.3002 30.3965 21.3002 30.8858C21.3002 31.0904 21.3529 31.3017 21.4669 31.5104C21.5817 31.7203 21.7593 31.928 22.0038 32.1133C22.2483 32.2986 22.5502 32.454 22.8959 32.5626C23.2415 32.6711 23.6172 32.7284 24.0001 32.7284C24.3828 32.7284 24.7586 32.6711 25.1041 32.5626C25.4498 32.454 25.7517 32.2986 25.9963 32.1133C26.2407 31.928 26.4184 31.7203 26.5332 31.5104C26.6472 31.3017 26.6998 31.0904 26.6998 30.8858C26.6998 30.3965 27.1028 30 27.5999 30C28.097 30 28.5 30.3965 28.5 30.8858C28.5 31.3978 28.3664 31.896 28.1186 32.3495C27.8716 32.8014 27.5189 33.1954 27.0948 33.5169C26.6707 33.8381 26.1789 34.0847 25.6512 34.2504C25.1233 34.4161 24.5627 34.5 24.0001 34.5C23.4373 34.5 22.8767 34.4161 22.3488 34.2504C21.8211 34.0847 21.3293 33.8381 20.9053 33.5169C20.4811 33.1954 20.1284 32.8014 19.8814 32.3495C19.6336 31.896 19.5 31.3978 19.5 30.8858C19.5 30.3965 19.903 30 20.4001 30Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0413 7.18929C22.0603 5.6549 25.5979 5.60271 28.659 7.04738L28.9326 7.17649C32.1402 8.69028 34.1938 11.97 34.1938 15.5788V17.3686C34.1938 18.8073 34.5008 20.2286 35.0934 21.5337L35.4473 22.3131C37.0726 25.8927 34.9559 30.0769 31.1568 30.7941L30.9426 30.8345C26.2427 31.7218 21.4232 31.7218 16.7232 30.8345C12.8729 30.1077 10.836 25.7571 12.6991 22.24L13.0018 21.6685C13.7491 20.2578 14.1404 18.6792 14.1404 17.0754V15.271C14.1404 11.8457 16.0387 8.71536 19.0413 7.18929ZM27.8177 8.90682C25.3088 7.72274 22.4093 7.76552 19.9348 9.02314C17.6135 10.2029 16.146 12.6229 16.146 15.271V17.0754C16.146 19.0197 15.6717 20.9332 14.7658 22.6432L14.4631 23.2147C13.2479 25.5086 14.5765 28.3463 17.0877 28.8203C21.5467 29.662 26.1191 29.662 30.5781 28.8203L30.7923 28.7798C33.303 28.3058 34.702 25.5406 33.6278 23.1748L33.2739 22.3955C32.5587 20.8203 32.1882 19.1049 32.1882 17.3686V15.5788C32.1882 12.7687 30.5891 10.2147 28.0913 9.03593L27.8177 8.90682Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_162_5529",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.270588 0 0 0 0 0.447059 0 0 0 0 0.545098 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_162_5529"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_162_5529",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyIcon);
export default __webpack_public_path__ + "static/media/notify_icon.1b687ee605360c98e0ebf09f5f15f63a.svg";
export { ForwardRef as ReactComponent };